export default __webpack_public_path__ + "images/logoSkinDesignLondon.ac9e8332104451d5f98d7ae24a4dd9ae.svg"